const calendarContainer = '[data-calendar]';
const calendarEndPoint = '/calendar';

async function loadCalendar(monthSlug = '', daySlug = '') {
    try {
        let url = monthSlug ? `${calendarEndPoint}/${monthSlug}` : calendarEndPoint;
        if (daySlug) {
            url += `?day=${daySlug}`;
        }
        const response = await fetch(url);
        const html = await response.text();
        document.querySelector(calendarContainer).innerHTML = html;
        initializeCalendarNavigation();
    } catch (error) {
        console.error('Error loading calendar:', error);
    }
}

function initializeCalendarNavigation() {
    const prevButton = document.querySelector('[data-calendar-previous]');
    const nextButton = document.querySelector('[data-calendar-next]');

    if (prevButton) {
        const prevMonth = prevButton.getAttribute('data-calendar-previous');
        if (prevMonth) {
            prevButton.style.cursor = 'pointer';
            prevButton.addEventListener('click', () => loadCalendar(prevMonth));
        }
    }

    if (nextButton) {
        const nextMonth = nextButton.getAttribute('data-calendar-next');
        if (nextMonth) {
            nextButton.style.cursor = 'pointer';
            nextButton.addEventListener('click', () => loadCalendar(nextMonth));
        }
    }

    const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]');
    [...tooltipTriggerList].map(tooltipTriggerEl => new bootstrap.Tooltip(tooltipTriggerEl));
}

loadCalendar(currentMonthName, currentDay);

(function () {
    // querySelectorAll, not querySelector: _ArticlePreview puts [data-share-buttons] on every
    // card, so every listing page has one of these per result. Binding only the first left the
    // Copy link and Share buttons inert on every card below it.
    document.querySelectorAll('[data-share-buttons]').forEach((container) => {
        const url = decodeURIComponent(container.dataset.shareButtons);
        const title = container.dataset.title;

        // Copy link
        const copyBtn = container.querySelector('[data-copy-link]');
        const copyLabel = container.querySelector('[data-copy-label]');
        if (copyBtn) {
            copyBtn.addEventListener('click', () => {
                navigator.clipboard.writeText(decodeURIComponent(url)).then(() => {
                    copyLabel.textContent = 'Copied!';
                    setTimeout(() => { copyLabel.textContent = 'Copy link'; }, 2000);
                });
            });
        }

        // Web Share API (mobile)
        const webShareBtn = container.querySelector('[data-web-share]');
        if (webShareBtn && navigator.share) {
            webShareBtn.classList.remove('d-none');
            webShareBtn.addEventListener('click', () => {
                navigator.share({ title, url: decodeURIComponent(url) });
            });
        }
    });
}());

(function () {
    const article = document.querySelector('[data-article-content]');
    const bar = document.querySelector('[data-progress-bar]');

    // Reading progress bar
    if (article && bar) {
        const update = () => {
            const rect = article.getBoundingClientRect();
            const total = article.offsetHeight - window.innerHeight;
            const scrolled = -rect.top;
            let pct = total > 0 ? scrolled / total : 0;
            pct = Math.max(0, Math.min(1, pct));
            bar.style.width = (pct * 100) + '%';
        };
        window.addEventListener('scroll', update, { passive: true });
        window.addEventListener('resize', update, { passive: true });
        update();
    }

    // Table-of-contents scroll spy
    const tocLinks = Array.from(document.querySelectorAll('[data-toc-list] a'));
    const items = Array.from(document.querySelectorAll('[data-toc-item]'));
    if (tocLinks.length && items.length && 'IntersectionObserver' in window) {
        const linkById = {};
        tocLinks.forEach(a => {
            linkById[a.getAttribute('href').slice(1)] = a;
        });

        const visible = new Set();
        const setActive = (id) => {
            tocLinks.forEach(a => a.classList.remove('active'));
            if (id && linkById[id]) linkById[id].classList.add('active');
        };

        const observer = new IntersectionObserver((entries) => {
            entries.forEach(e => {
                if (e.isIntersecting) visible.add(e.target.id);
                else visible.delete(e.target.id);
            });
            const firstVisible = items.find(el => visible.has(el.id));
            if (firstVisible) setActive(firstVisible.id);
        }, { rootMargin: '-20% 0px -70% 0px', threshold: 0 });

        items.forEach(el => observer.observe(el));

        // On mobile, collapse the ToC panel after picking a section
        tocLinks.forEach(a => {
            a.addEventListener('click', () => {
                const panel = document.getElementById('toc-collapse');
                if (panel && panel.classList.contains('show') && window.innerWidth < 1200
                    && window.bootstrap && bootstrap.Collapse) {
                    bootstrap.Collapse.getOrCreateInstance(panel).hide();
                }
            });
        });
    }
}());

(function () {
    // Count-up animation for the home page intro stats
    const els = Array.from(document.querySelectorAll('[data-count-up]'));
    if (!els.length) return;

    const format = (n) => Math.round(n).toLocaleString();
    const reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    const animate = (el) => {
        const target = parseInt(el.getAttribute('data-count-up'), 10) || 0;
        if (reduceMotion || target <= 0) {
            el.textContent = format(target);
            return;
        }
        const duration = 1200;
        const start = performance.now();
        const step = (now) => {
            const p = Math.min(1, (now - start) / duration);
            const eased = 1 - Math.pow(1 - p, 3); // ease-out cubic
            el.textContent = format(target * eased);
            if (p < 1) requestAnimationFrame(step);
            else el.textContent = format(target);
        };
        el.textContent = '0';
        requestAnimationFrame(step);
    };

    if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver((entries) => {
            entries.forEach((e) => {
                if (e.isIntersecting) {
                    animate(e.target);
                    observer.unobserve(e.target);
                }
            });
        }, { threshold: 0.4 });
        els.forEach((el) => observer.observe(el));
    } else {
        els.forEach(animate);
    }
}());

(function () {
    const btn = document.getElementById('back-to-top');
    if (!btn) return;

    window.addEventListener('scroll', () => {
        btn.style.display = window.scrollY > 300 ? 'block' : 'none';
    }, { passive: true });

    btn.addEventListener('click', () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    });
}());
